import React from "react";

function Spinner() {
  return (
    <div className="w-full flex items-center justify-center h-[87vh]">
      <div className="loader">
        <div className="justify-content-center jimu-primary-loading"></div>
      </div>
    </div>
  );
}

export default Spinner;
